export const FORMULA_LIST_SUCCESS = 'FORMULA_LIST_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const FORMULA_DETAIL_SUCCESS = 'FORMULA_DETAIL_SUCCESS';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
